import React, { useEffect, useState } from "react";
import API from "../services/api";

function Inventory() {
  const [machines, setMachines] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [slots, setSlots] = useState([]);

  const [slotCode, setSlotCode] = useState("");
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [stockQty, setStockQty] = useState("");
  /** Borrador por slot: unidades a sumar en reposición (delta positivo). */
  const [reposicionDraft, setReposicionDraft] = useState({});

  const loadMachines = () => API.get("/machines").then(res => setMachines(res.data));

  const loadSlots = id => API.get(`/stock/${id}`).then(res => setSlots(res.data));

  useEffect(() => {
    loadMachines();
  }, []);

  const createSlot = async () => {
    if (!selectedMachine) {
      alert("Debe seleccionar una máquina");
      return;
    }

    try {
      await API.post("/stock", {
        machine_id: selectedMachine,
        slot_code: slotCode,
        product_name: productName,
        price: parseInt(price, 10),
        stock: parseInt(stockQty, 10)
      });

      setSlotCode("");
      setProductName("");
      setPrice("");
      setStockQty("");
      loadSlots(selectedMachine);
    } catch (error) {
      alert("Error al crear slot");
    }
  };

  const formatCLP = value =>
    new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP"
    }).format(value || 0);

  return (
    <div>
      <header className="page-header">
        <h1 className="page-title">Inventario</h1>
        <p className="page-subtitle">
          Cada venta registrada (SumUp → app Vikingo → backend) descuenta 1 unidad del slot.
          Las <strong>reposiciones</strong> suman unidades al stock actual (ej. si quedan 5 y repone 18,
          queda 23). También podés fijar el stock en un valor absoluto. Las ventas mostradas cuentan
          filas en Vikingo, no el portal SumUp directamente.
        </p>
      </header>

      <div className="card card--padded" style={{ marginBottom: "1.25rem" }}>
        <h2 className="section-title">Seleccionar máquina</h2>
        <select
          className="select"
          value={selectedMachine}
          onChange={e => {
            const value = e.target.value;
            setSelectedMachine(value);
            value ? loadSlots(value) : setSlots([]);
          }}
          style={{ maxWidth: "360px" }}
        >
          <option value="">Seleccionar máquina</option>
          {machines.map(machine => (
            <option key={machine.id} value={machine.id}>
              {machine.name}
            </option>
          ))}
        </select>
      </div>

      {selectedMachine && (
        <>
          <div className="card card--padded" style={{ marginBottom: "1.25rem" }}>
            <h2 className="section-title">Crear slot</h2>
            <div className="field-row">
              <input
                className="input"
                placeholder="Código slot"
                value={slotCode}
                onChange={e => setSlotCode(e.target.value)}
              />
              <input
                className="input"
                placeholder="Producto"
                value={productName}
                onChange={e => setProductName(e.target.value)}
                style={{ minWidth: "160px" }}
              />
              <input
                className="input"
                placeholder="Precio CLP"
                type="number"
                value={price}
                onChange={e => setPrice(e.target.value)}
                style={{ maxWidth: "120px" }}
              />
              <input
                className="input"
                placeholder="Stock inicial"
                type="number"
                value={stockQty}
                onChange={e => setStockQty(e.target.value)}
                style={{ maxWidth: "120px" }}
              />
              <button type="button" className="btn btn-primary" onClick={createSlot}>
                Crear slot
              </button>
            </div>
          </div>

          <h2 className="section-title">Stock actual</h2>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {slots.map(slot => (
              <li
                key={slot.id}
                className="card card--padded"
                style={{
                  marginBottom: "0.65rem",
                  borderLeft: `4px solid ${
                    slot.stock === 0 ? "var(--color-danger)" : slot.stock <= 2 ? "var(--color-warning)" : "var(--color-accent)"
                  }`
                }}
              >
                <div style={{ marginBottom: "0.35rem" }}>
                  <strong>{slot.slot_code}</strong> — {slot.product_name} — {formatCLP(slot.price)}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9rem",
                    color: "var(--color-text-secondary)"
                  }}
                >
                  <span>
                    Vendidas (30 d):{" "}
                    <strong>{slot.units_sold_30d != null ? slot.units_sold_30d : "—"}</strong>
                  </span>
                  <span>
                    Vendidas (total):{" "}
                    <strong>{slot.units_sold_total != null ? slot.units_sold_total : "—"}</strong>
                  </span>
                </div>
                <div
                  style={{
                    marginTop: "0.55rem",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "0.5rem"
                  }}
                >
                  <label style={{ color: "var(--color-text-muted)", fontSize: "0.88rem" }}>
                    Stock (ajuste absoluto)
                    <input
                      key={`${slot.id}-abs-${slot.stock}`}
                      className="input"
                      type="number"
                      defaultValue={slot.stock}
                      onBlur={async e => {
                        try {
                          await API.put(`/stock/${slot.id}`, {
                            stock: parseInt(e.target.value, 10)
                          });
                          loadSlots(selectedMachine);
                        } catch (err) {
                          alert("Error actualizando stock");
                        }
                      }}
                      style={{ width: "72px", marginLeft: "6px" }}
                    />
                  </label>
                  <label style={{ color: "var(--color-text-muted)", fontSize: "0.88rem" }}>
                    + Reposición
                    <input
                      className="input"
                      type="number"
                      min={1}
                      placeholder="ej. 18"
                      value={reposicionDraft[slot.id] ?? ""}
                      onChange={e =>
                        setReposicionDraft(prev => ({
                          ...prev,
                          [slot.id]: e.target.value
                        }))
                      }
                      style={{ width: "80px", marginLeft: "6px" }}
                    />
                  </label>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={async () => {
                      const raw = reposicionDraft[slot.id];
                      const n = parseInt(raw, 10);
                      if (!Number.isInteger(n) || n <= 0) {
                        alert("Indicá cuántas unidades se repusieron (número entero > 0).");
                        return;
                      }
                      try {
                        await API.put(`/stock/${slot.id}`, { reposicion: n });
                        setReposicionDraft(prev => {
                          const next = { ...prev };
                          delete next[slot.id];
                          return next;
                        });
                        await loadSlots(selectedMachine);
                      } catch (err) {
                        alert(err?.response?.data?.error || "Error registrando reposición");
                      }
                    }}
                  >
                    Aplicar reposición
                  </button>
                  {slot.stock === 0 && (
                    <span style={{ color: "var(--color-danger)", fontWeight: 600 }}>Sin stock</span>
                  )}
                  {slot.stock > 0 && slot.stock <= 2 && (
                    <span style={{ color: "var(--color-warning)", fontWeight: 600 }}>Stock bajo</span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default Inventory;
